import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, vShow as _vShow, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "gradient w-full h-1/4 absolute left-0 bottom-0 bg-gradient-to-t from-black to-transparent opacity-50" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "container w-full mx-auto px-4 py-8 lg:w-1/2" }
const _hoisted_5 = { class: "text-xl text-center font-bold" }
const _hoisted_6 = { class: "text-center text-sm text-gray-600 mb-4" }
const _hoisted_7 = { class: "text-center mb-8" }
const _hoisted_8 = {
  class: "form flex flex-col gap-4",
  ref: "form"
}
const _hoisted_9 = { class: "formRow flex flex-col gap-4 md:flex-row" }
const _hoisted_10 = { class: "formRow flex flex-col gap-4 md:flex-row" }
const _hoisted_11 = { class: "formRow flex justify-center" }
const _hoisted_12 = { class: "formField w-fit flex gap-2 items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmation",
  class: "cursor-pointer"
}, [
  /*#__PURE__*/_createElementVNode("p", null, "¿Confirma asistencia?")
], -1)
const _hoisted_14 = { class: "formRow flex justify-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, "Registrarse", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "loading mx-auto flex flex-col gap-4 text-center items-center md:w-1/2 px-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-32 h-32",
  src: "/assets/img/qr-code-outline.gif",
  alt: "Loading"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold" }, "Generando invitación"),
  /*#__PURE__*/_createElementVNode("p", null, "Aguarde un momento")
], -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "confirmationMsg mx-auto flex flex-col gap-4 text-center items-center md:w-1/2 px-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-32 h-32",
  src: "/assets/img/confetti-outline.gif",
  alt: "Success"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold" }, "Su invitación fue creada", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, " Se le ha enviado un email con los detalles de la misma. Si lo desea puede verla y descargarla a través del siguiente botón. ", -1)
const _hoisted_25 = { class: "buttonContainer flex justify-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, "Ver invitación", -1)
const _hoisted_27 = { class: "errorMsg mx-auto flex flex-col gap-4 text-center items-center md:w-1/2 px-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-32 h-32",
  src: "/assets/img/error-outline.gif",
  alt: "Error"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold" }, "No se pudo generar la invitación", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Hubo un error al completar la acción."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Por favor intente nuevamente. ")
], -1)
const _hoisted_31 = { class: "buttonContainer flex justify-center" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, "Reintentar", -1)
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ToastAlert = _resolveComponent("ToastAlert")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home", (_ctx.status == 'idle') ? 'relative' : 'flex items-center'])
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "background relative w-full bg-gray-200 bg-cover bg-center aspect-[3/1] lg:aspect-[6/1]",
        style: _normalizeStyle('background-image:url('+_ctx.config.background+')')
      }, _hoisted_3, 4),
      _createElementVNode("div", {
        class: "mainImage relative w-32 -mt-16 aspect-square bg-gray-300 mx-auto lg:w-48 lg:-mt-24 rounded-full bg-center bg-cover",
        style: _normalizeStyle('background-image:url('+_ctx.config.mainImage+')')
      }, null, 4),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.config.eventName), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.config.eventDate +' - '+ _ctx.config.eventLocation), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.config.eventText), 1),
        _createElementVNode("form", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              class: "w-full border border-gray-300 p-2 rounded-lg shadow-md",
              type: "text",
              name: "firstName",
              id: "firstName",
              placeholder: "Nombre",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.firstName]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "w-full border border-gray-300 p-2 rounded-lg shadow-md",
              type: "text",
              name: "lastName",
              id: "lastName",
              placeholder: "Apellido",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lastName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.lastName]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              class: "w-full border border-gray-300 p-2 rounded-lg shadow-md",
              type: "email",
              name: "email",
              id: "email",
              placeholder: "Email",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            _createVNode(_component_vue_tel_input, {
              class: "w-full h-10",
              modelValue: _ctx.phone,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phone) = $event)),
              mode: "international",
              defaultCountry: "AR",
              autoFormat: true,
              dropdownOptions: {disabled: true, showFlags: true},
              inputOptions: {placeholder: 'Ingrese su nro'},
              onValidate: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validatePhone($event)))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                name: "confirmation",
                id: "confirmation",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmation) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.confirmation]
              ]),
              _hoisted_13
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "button bg-cyan-500 rounded-lg py-2 px-4 hover:bg-cyan-700 cursor-pointer",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.register()))
            }, _hoisted_16)
          ])
        ], 512)
      ])
    ], 512), [
      [_vShow, _ctx.status == 'idle']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_17, _hoisted_20, 512), [
      [_vShow, _ctx.status == 'loading']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _hoisted_23,
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_router_link, {
          to: '/invitacion/'+_ctx.qrId,
          class: "button bg-cyan-500 rounded-lg py-2 px-4"
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ], 512), [
      [_vShow, _ctx.status == 'success']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_27, [
      _hoisted_28,
      _hoisted_29,
      _hoisted_30,
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", {
          class: "button bg-cyan-500 rounded-lg py-2 px-4 cursor-pointer",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.retry()))
        }, _hoisted_33)
      ])
    ], 512), [
      [_vShow, _ctx.status == 'error']
    ]),
    _createVNode(_component_ToastAlert, { ref: "toast" }, null, 512)
  ], 2))
}